
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as yup from 'yup';

import Modal, { ModalHeader, ModalSubtitle, ModalContent, ModalActions } from 'components/Modal';
import Button, { CopyButton } from 'components/Button';
import UserCard from 'components/UserCard';
import CopyInput from 'components/forms/CopyInput';

// ======================
// STORE
// ====================== 
const actions = {
  
}

const selectors = state => {
  return {

  };
}

const withConnect = connect(selectors, actions);

// ======================
// COMPONENT
// ====================== 
class UrlModal extends React.Component {

  onFocus = e => {
    e.target.select();
  }

  onCopyClick = (e) => {
    let { text } = this.props;
    this.refs.url.select();
    document.execCommand('copy');
    this.refs.url.focus();
  };
  
  render() {
    let { url, streamer, avatarUrl } = this.props;
    return (
      <Modal id="urlModal" className="s">
        <ModalHeader>
          <UserCard 
            user={{ avatarUrl, username: streamer}}
            layout="hor"
            size="l" />
          <ModalSubtitle>Instructions For {streamer} Slideshow</ModalSubtitle>
        </ModalHeader>
        <ModalContent>
          <div className="step">
            <div className="label"><strong>Step 1:</strong> Add URL to Browser Source Plugin for OBS</div>
            <div className="url-input">
              <CopyInput
                value={url}
                onFocus={this.onFocus} />
            </div>
          </div>
          <div className="step">
            <div className="label"><strong>Step 2:</strong> Check 'Shutdown Source' setting</div>
            <img src="/assets/images/obs_shutdown_setting.png" />
          </div>
        </ModalContent>
        <ModalActions>
          <Button onClick={this.props.onClose}>Done</Button>
        </ModalActions>
      </Modal>);
  }
};
export default UrlModal 
  |> withConnect
